function filter_toggle(section_id){
  jQuery('#filter--lightbox-wrapper').find('.boost-pfs-filter-button.boost-pfs-filter-option-title-heading').trigger('click');
  jQuery('#'+section_id).toggleClass('active');
  jQuery('html').toggleClass('drawer-open');
}

function get_url_param(name){
  var r = /[?&]([^=#]+)=([^&#]*)/g,p={},match;
  while(match = r.exec(window.location)) p[match[1]] = match[2];
  return p[name];
}

function refineUrl()
{
  //get full url
  var url = window.location.href;
  //get url after/
  var value = url = url.slice( 0, url.indexOf('?') );
  //get the part after before ?
  value  = value.replace('@System.Web.Configuration.WebConfigurationManager.AppSettings["BaseURL"]','');
  return value;
}



$(document).ready(function(){



  $(".mega-menu").hover(function(){
    $('body').addClass('megamenu-active');
  }, function(){
    $('body').removeClass('megamenu-active');
  });

  $(".navbar-icon").click(function(){
    $("body").toggleClass('mobilemenu-active');
    $(".dropdown-mobile").removeClass('dropdown-mobile-active');
  });

  $(".have-mobile-sub-menu .nav-link").click(function() {
    $(this).next(".dropdown-mobile").addClass('dropdown-mobile-active');
  });

  $(".goback").click(function() {
    $(this).closest(".dropdown-mobile").toggleClass('dropdown-mobile-active');
  });

  $("#toggle-filterbox").click(function(){
    $("#product-sidebar").addClass("filteractive");
    $('body').addClass('filterbody-active');
  });


  $("#close-filter").click(function(){
    $("#product-sidebar").removeClass("filteractive");
    $('body').removeClass('filterbody-active');
  });

  /* owl */



  $(document).ready(function() {
    if($('.owl-carousel-slider-hdd').length > 0){
      $('.owl-carousel-slider-hdd').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        touchThreshold:50,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 766,
            settings: {
              dots: true,
              infinite: false,
              slidesToShow: 2,
            }
          }

        ]
      });
    }

    if($('.owl-relatied-products').length > 0){
      $('.owl-relatied-products').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        touchThreshold: 50,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2,
              dots: true,
            }
          },
          {
            breakpoint: 668,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: true,
            }
          }

        ]
      });
    }

    if($('.brand-carousl').length > 0){
      $('.brand-carousl').slick({
        dots: false,
        arrow: true,
        prevArrow: '<div class="slick-arrow arrow-left"><img src="//dossier.co/cdn/shop/t/245/assets/angle-left.svg?v=53672727868888068891648727211" alt="arrow" /></div>',
        nextArrow: '<div class="slick-arrow arrow-right"><img src="//dossier.co/cdn/shop/t/245/assets/angle-right.svg?v=164853121399329597331648727212" alt="arrow" /></div>',
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        touchThreshold: 50,
        centerPadding: '0px',
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2,
              dots: false,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false,
            }
          },
          {
            breakpoint: 620,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
            }
          }

        ]
      });
    }


    if($('.candle-slider-wrapper').length > 0){
      $('.candle-slider-wrapper').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        touchThreshold: 50,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 766,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: true,
            }
          }

        ]
      });
    }

    if($('#exploreslider').length > 0){
      $('#exploreslider').slick({
        dots: true,
        infinite: true,
        speed: 600,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        touchThreshold: 50,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 999,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: true,
            }
          },
          {
            breakpoint: 581,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
            }
          }

        ]
      });
    }

    if($('.category-products-carousel').length > 0){
      $('.category-products-carousel').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        touchThreshold: 20,
        slidesToScroll: 1

      });
    }

    if($('.product-slider').length > 0){
      $('.product-slider').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        touchThreshold: 50,
        accessibility: false,
        draggable: false,
        slidesToScroll: 1,
        asNavFor: '.gallery-thumbnail',
        responsive: [
          {
            breakpoint: 766,
            settings: {
              dots: true,
            }
          }

        ]
      });
    }

    if($('.gallery-thumbnail').length > 0){
      $('.gallery-thumbnail').slick({
        dots: false,
        infinite: false,
        vertical: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        touchThreshold:50,
        verticalSwiping: true,
        accessibility: false,
        draggable: false,
        focusOnSelect: true,
        centerMode: false,
        centerPadding: '0px',
        asNavFor: '.product-slider',
        prevArrow:"<button type='button' class='slick-prev slick-arrow'><img src='//dossier.co/cdn/shop/t/245/assets/angle-left.svg?v=53672727868888068891648727211' /></button>",
        nextArrow:"<button type='button' class='slick-next slick-arrow'><img src='//dossier.co/cdn/shop/t/245/assets/angle-right.svg?v=164853121399329597331648727212' /></button>",
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              dots: true,
              slidesToShow: 4,
              slidesToScroll: 1,
            }
          }

        ]
      });
    }


    if($(window).width() < 766){

      $('.holiday-mobile-carousel').slick({
        dots: true,
        infinite: false,
        vertical: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        touchThreshold:50,
        centerMode: false,
        centerPadding: '0px',
        responsive: [
          {
            breakpoint: 3000,
            settings: {
              dots: true,
              slidesToShow: 5,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 480,
            settings: {
              dots: true,
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          }

        ]
      });



    }

    $(window).on('resize', function(){

      if($(window).width() < 766){

        $('.holiday-mobile-carousel').slick({
          dots: true,
          infinite: false,
          vertical: false,
          slidesToShow: 2,
          slidesToScroll: 2,
          touchThreshold:50,
          centerMode: false,
          centerPadding: '0px',
          responsive: [
            {
              breakpoint: 3000,
              settings: {
                dots: true,
                slidesToShow: 5,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 480,
              settings: {
                dots: true,
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            }

          ]
        });



      }
    });




    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      e.target // newly activated tab
      e.relatedTarget // previous active tab
      $(".owl-carousel").trigger('refresh.owl.carousel');
    });
  });



  /* End Owl */

  if($('[data-toggle="tooltip"]').length > 0){
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
      $(".them-lodar").fadeOut(2000)
    })
  }

  /* Review */
  $("#comment-form-box").slideUp(0);

  $("#toggle-reviewform").click(function(){
    $("#comment-form-box").slideToggle(500);
    $(this).toggleClass('commentbutton-active');

  });

  $(".user-review-item-01").click(function(){
    $(this).closest(".user-review").addClass("user-rating-01");

    $(this).closest(".user-review").removeClass("user-rating-02");
    $(this).closest(".user-review").removeClass("user-rating-03");
    $(this).closest(".user-review").removeClass("user-rating-04");
    $(this).closest(".user-review").removeClass("user-rating-05");
  });

  $(".user-review-item-02").click(function(){
    $(this).closest(".user-review").addClass("user-rating-02");

    $(this).closest(".user-review").removeClass("user-rating-01");
    $(this).closest(".user-review").removeClass("user-rating-03");
    $(this).closest(".user-review").removeClass("user-rating-04");
    $(this).closest(".user-review").removeClass("user-rating-05");
  });

  $(".user-review-item-03").click(function(){
    $(this).closest(".user-review").addClass("user-rating-03");

    $(this).closest(".user-review").removeClass("user-rating-01");
    $(this).closest(".user-review").removeClass("user-rating-02");
    $(this).closest(".user-review").removeClass("user-rating-04");
    $(this).closest(".user-review").removeClass("user-rating-05");
  });


  $(".user-review-item-04").click(function(){
    $(this).closest(".user-review").addClass("user-rating-04");

    $(this).closest(".user-review").removeClass("user-rating-01");
    $(this).closest(".user-review").removeClass("user-rating-02");
    $(this).closest(".user-review").removeClass("user-rating-03");
    $(this).closest(".user-review").removeClass("user-rating-05");
  });

  $(".user-review-item-05").click(function(){
    $(this).closest(".user-review").addClass("user-rating-05");

    $(this).closest(".user-review").removeClass("user-rating-01");
    $(this).closest(".user-review").removeClass("user-rating-02");
    $(this).closest(".user-review").removeClass("user-rating-03");
    $(this).closest(".user-review").removeClass("user-rating-04");
  });


  var urlpara = new URLSearchParams(window.location.search);
  var keys = urlpara.keys();
  var entries = urlpara.entries();

  for(pair of entries){
    /*if(pair[0] == "gf_36371"){
         var val = pair[1];
           if(pair[1] == 'Unisex'){
              $(".cat-collection-title").replaceWith('<h1 class="text-uppercase m-0 cat-collection-title"><span id="first_text">Unisex </span><span id="second_text">Fragrances</span></h1>');
          }else{
                var value = '<span id="first_text">'+ pair[1]+"'s "+'</span><span id="second_text">'+" Fragrances"+"</span>";
              $(".cat-collection-title").replaceWith('<h1 class="text-uppercase m-0 cat-collection-title">'+value+'</h1>');
          }
       }*/
    if(pair[0] == "pf_pt_gender"){
      var val = pair[1];
      if(pair[1] == 'Unisex'){
        $(".cat-collection-title").replaceWith('<h1 class="text-uppercase m-0 cat-collection-title"><span id="first_text">Unisex </span><span id="second_text">Fragrances</span></h1>');
      }else{
        var value = '<span id="first_text">'+ pair[1]+"'s "+'</span><span id="second_text">'+" Fragrances"+"</span>";
        $(".cat-collection-title").replaceWith('<h1 class="text-uppercase m-0 cat-collection-title">'+value+'</h1>');
      }
    }
    if(pair[0] == "pf_pt_gender"){
      var val = pair[1];
      if(pair[1] == 'Men'){
        var image_de="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Men_s_Header_Promo_desktop.png?v=1619014888";
        $(".template-collection #coll_desk img").attr('src', image_de);
        var image_mo="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Men_s_Header_mobile_2.png?v=1619015562";
        $(".template-collection #coll_mobile img").attr('src', image_mo);
      }
      else if(pair[1] == 'Women'){
        var image_de="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Women_s_Header_Promo_desktop.png?v=1619014888";
        $(".template-collection #coll_desk img").attr('src', image_de);
        var image_mo="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Women_s_Header_mobile_2.png?v=1619015562";
        $(".template-collection #coll_mobile img").attr('src', image_mo);

      }
      else if(pair[1] == 'Unisex'){
        var image_de="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Unisex_Header_Promo_desktop.png?v=1619014888";
        $(".template-collection #coll_desk img").attr('src', image_de);
        var image_mo="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Unisex_Header_mobile_1.png?v=1619015562";
        $(".template-collection #coll_mobile img").attr('src', image_mo);

      }
    }
    break;
  }

  setInterval(function(){
    var urlpara = new URLSearchParams(window.location.search);
    var keys = urlpara.keys();
    var entries = urlpara.entries();

    for(pair of entries){
      /*if(pair[0] == "gf_36371"){
           var val = pair[1];
             if(pair[1] == 'Unisex'){
                $(".cat-collection-title").replaceWith('<h1 class="text-uppercase m-0 cat-collection-title"><span id="first_text">Unisex </span><span id="second_text">Fragrances</span></h1>');
            }else{
                  var value = '<span id="first_text">'+ pair[1]+"'s "+'</span><span id="second_text">'+" Fragrances"+"</span>";
                $(".cat-collection-title").replaceWith('<h1 class="text-uppercase m-0 cat-collection-title">'+value+'</h1>');
            }
         }*/
      if(pair[0] == "pf_pt_gender"){
        var val = pair[1];
        if(pair[1] == 'Unisex'){
          $(".cat-collection-title").replaceWith('<h1 class="text-uppercase m-0 cat-collection-title"><span id="first_text">Unisex </span><span id="second_text">Fragrances</span></h1>');
        }else{
          var value = '<span id="first_text">'+ pair[1]+"'s "+'</span><span id="second_text">'+" Fragrances"+"</span>";
          $(".cat-collection-title").replaceWith('<h1 class="text-uppercase m-0 cat-collection-title">'+value+'</h1>');
        }
      }
      if(pair[0] == "pf_pt_gender"){
        var val = pair[1];
        if(pair[1] == 'Men'){
          var image_de="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Men_s_Header_Promo_desktop.png?v=1619014888";
          $(".template-collection #coll_desk img").attr('src', image_de);
          var image_mo="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Men_s_Header_mobile_2.png?v=1619015562";
          $(".template-collection #coll_mobile img").attr('src', image_mo);
        }
        else if(pair[1] == 'Women'){
          var image_de="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Women_s_Header_Promo_desktop.png?v=1619014888";
          $(".template-collection #coll_desk img").attr('src', image_de);
          var image_mo="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Women_s_Header_mobile_2.png?v=1619015562";
          $(".template-collection #coll_mobile img").attr('src', image_mo);

        }
        else if(pair[1] == 'Unisex'){
          var image_de="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Unisex_Header_Promo_desktop.png?v=1619014888";
          $(".template-collection #coll_desk img").attr('src', image_de);
          var image_mo="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Unisex_Header_mobile_1.png?v=1619015562";
          $(".template-collection #coll_mobile img").attr('src', image_mo);

        }
      }
      break;
    }

  }, 300);

});


/*  Filter box  */


/* Sticky Header */
// $(window).scroll(function() {
//   var scroll = $(window).scrollTop();
//   if (scroll >= 300) {
//       $("body").addClass("stickyheader-active");
//   } else {
//       $("body").removeClass("stickyheader-active");
//   }
// });
$(window).scroll(function() {
  var scroll = $(window).scrollTop();
  if (scroll >= 30) {
    $("body").addClass("stickyheader-active");
  } else {
    $("body").removeClass("stickyheader-active");
  }
});
/* End Sticky Header */

/* Popup owl-man*/

/* More In Side bar */

//cache the lis since we need to use it again
var $lis = $('#filtercheckbox-list-01 .filtercheckbox-list-item');

if ($lis.length > 10) {
  $lis.slice(+10).addClass("item-on-more");
}

/*End More In Side bar */

$("#filtercheckbox-list-01 .clear-linkbox-link").click(function() {
  //filtercheckbox-list-01
  $(this).closest("#filtercheckbox-list-01").toggleClass('product-morefeilds');
  if($(this).closest("#filtercheckbox-list-01").hasClass('product-morefeilds')){
    $(this).text('— Show fewer brands');
  }
  else{
    $(this).text('+ 34 more brands');

  }

});


$(".filter-collabs-item").slideUp();

$(".filtercollabs-box-h3").click( function(){
  $(this).toggleClass("filtercollabs-box-title-active");
  $(this).next(".filter-collabs-item").slideToggle(500);

});


/* Counte Product */


var count = 1;
var countEl = document.getElementById("count");
function plus(){
  count++;
  countEl.value = count;
}
function minus(){
  if (count > 1) {
    count--;
    countEl.value = count;
  }
}


/* Cart toggle */

$("#cart-toggle,#cart-close, .cart-overlay").click(function(){
  $("body").toggleClass("cart-box-active");
});

function howManyItems() {
  let allVal = 0,
    freeShippingSlider = $('#free-shipping-slider');
  $("#CartContainer .ajaxcart__qty-num").each(function () {
    allVal = allVal + parseInt($(this).val());
  });
  freeShippingSlider.html('');
  /*
  new code
  if (allVal === 1) {
     let string = '<div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 33.33%" aria-valuenow="33.33" aria-valuemin="0" aria-valuemax="100"></div>' + '</div>' + '<p class="productlisttitle text-center">' +	'<span id="top_wred">You are 2 products away from</span> <span id="top_red">15% off* + free shipping</span>' + '</p>'+'<div id="one_box_item" class="back_red_off">'+'<img src="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Screen_Shot_2020-06-29_at_11_7.png?v=1618229433" alt="one">'+'</div>'
         +'<div id="one_box_item">'+'<img src="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Screen_Shot_2020-06-29_at_11_7.png?v=1618229433" alt="two">'+'</div>'+'<div id="one_box_item" class="text_boxes_off">'+'15% OFF*'+'</div>'+'<div id="one_box_item" class="text_boxes_off">'+'18% OFF*'+'</div>'+'<div id="one_box_item" class="text_boxes_off">'+'20% OFF*'+'</div>'+'<div id="last_text_off">'+'<span>*on your entire order</span>'+'</div>' ;
     freeShippingSlider.html(string);
   }
       if (allVal === 2) {
     let string = '<div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 66.66%" aria-valuenow="33.33" aria-valuemin="0" aria-valuemax="100"></div>' + '</div>' + '<p class="productlisttitle text-center">' +	'<span id="top_wred">You are 1 product away from</span> <span id="top_red">15% off* + free shipping</span>' + '</p>'+'<div id="one_box_item" class="back_red_off">'+'<img src="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Screen_Shot_2020-06-29_at_11_7.png?v=1618229433" alt="one">'+'</div>'
         +'<div id="one_box_item" class="back_red_off">'+'<img src="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Screen_Shot_2020-06-29_at_11_7.png?v=1618229433" alt="two">'+'</div>'+'<div id="one_box_item" class="text_boxes_off">'+'15% OFF*'+'</div>'+'<div id="one_box_item" class="text_boxes_off">'+'18% OFF*'+'</div>'+'<div id="one_box_item" class="text_boxes_off">'+'20% OFF*'+'</div>'+'<div id="last_text_off">'+'<span>*on your entire order</span>'+'</div>' ;
     freeShippingSlider.html(string);
   }
       if (allVal == 3) {
     let string = '<div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>' + '</div>' + '<p class="productlisttitle text-center">' +	'<span id="top_red">Congrats! You get 15% off!*</span><span id="top_red" class="top_red_second">+ free shipping!</span>' + '</p>'
         +'<div id="one_box_item" class="back_red_off">'+'<img src="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Screen_Shot_2020-06-29_at_11_7.png?v=1618229433" alt="one">'+'</div>'
         +'<div id="one_box_item" class="back_red_off">'+'<img src="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Screen_Shot_2020-06-29_at_11_7.png?v=1618229433" alt="two">'+'</div>'+'<div id="one_box_item" class="text_boxes_off back_red_off">'+'15% OFF*'+'</div>'+'<div id="one_box_item" class="text_boxes_off">'+'18% OFF*'+'</div>'+'<div id="one_box_item" class="text_boxes_off">'+'20% OFF*'+'</div>'+'<div id="last_text_off">'+'<span>*on your entire order</span>'+'</div>';
     freeShippingSlider.html(string);
   }
     if (allVal == 4) {
     let string = '<div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>' + '</div>' + '<p class="productlisttitle text-center">' +	'<span id="top_red">Congrats! You get 18% off!*</span><span id="top_red" class="top_red_second">+ free shipping!</span>' + '</p>'
         +'<div id="one_box_item" class="back_red_off">'+'<img src="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Screen_Shot_2020-06-29_at_11_7.png?v=1618229433" alt="one">'+'</div>'
         +'<div id="one_box_item" class="back_red_off">'+'<img src="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Screen_Shot_2020-06-29_at_11_7.png?v=1618229433" alt="two">'+'</div>'+'<div id="one_box_item" class="text_boxes_off back_red_off">'+'15% OFF*'+'</div>'+'<div id="one_box_item" class="text_boxes_off back_red_off">'+'18% OFF*'+'</div>'+'<div id="one_box_item" class="text_boxes_off">'+'20% OFF*'+'</div>'+'<div id="last_text_off">'+'<span>*on your entire order</span>'+'</div>';
     freeShippingSlider.html(string);
   }
     if (allVal == 5) {
     let string = '<div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>' + '</div>' + '<p class="productlisttitle text-center">' +	'<span id="top_red">Congrats! You get 20% off!*</span><span id="top_red" class="top_red_second">+ free shipping!</span>' + '</p>'
         +'<div id="one_box_item" class="back_red_off">'+'<img src="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Screen_Shot_2020-06-29_at_11_7.png?v=1618229433" alt="one">'+'</div>'
         +'<div id="one_box_item" class="back_red_off">'+'<img src="https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Screen_Shot_2020-06-29_at_11_7.png?v=1618229433" alt="two">'+'</div>'+'<div id="one_box_item" class="text_boxes_off back_red_off">'+'15% OFF*'+'</div>'+'<div id="one_box_item" class="text_boxes_off back_red_off">'+'18% OFF*'+'</div>'+'<div id="one_box_item" class="text_boxes_off back_red_off">'+'20% OFF*'+'</div>'+'<div id="last_text_off">'+'<span>*on your entire order</span>'+'</div>';
     freeShippingSlider.html(string);
   }
     */
// 	if (allVal === 2) {
// 		let string = '<div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 66.66%" aria-valuenow="33.33" aria-valuemin="0" aria-valuemax="100"></div>' + '</div>' + '<p class="productlisttitle text-center">' +	'You are 1 product away from free shipping!' + '</p>' ;
// 		freeShippingSlider.html(string);
// 	}

  /*if (allVal === 3) {
  let string = '<div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 66.66%" aria-valuenow="33.33" aria-valuemin="0" aria-valuemax="100"></div>' + '</div>' + '<p class="productlisttitle text-center">' +	'You are 1 product away from free shipping!' + '</p>' ;
  freeShippingSlider.html(string);
}
  if (allVal === 4) {
  let string = '<div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 66.66%" aria-valuenow="33.33" aria-valuemin="0" aria-valuemax="100"></div>' + '</div>' + '<p class="productlisttitle text-center">' +	'CONGRATS! YOU GET FREE SHIPPING' + '</p>' ;
  freeShippingSlider.html(string);
}
  if (allVal === 5) {
  let string = '<div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 66.66%" aria-valuenow="33.33" aria-valuemin="0" aria-valuemax="100"></div>' + '</div>' + '<p class="productlisttitle text-center">' +	'CONGRATS! YOU GET FREE SHIPPING' + '</p>' ;
  freeShippingSlider.html(string);
}*/
  /* new code cart -->
      if (allVal === 1) {
    let string = '<div class="cart-step-progress"> <span class="step-box step-1 active"></span><span class="step-box step-2"></span><span class="step-box step-3"><span class="step-text">-15%</span></span><span class="step-box step-4"><span class="step-text">-18%</span></span><span class="step-box step-5"><span class="step-text">-20%</span></span></div>'
        +'<p class="productlisttitle text-center">' +	'<span id="top_wred">You are 2 products away from</span> <span id="top_red">15% off* + free shipping</span>'+'<span id="top_wred"> on your entire order!</span>' + '</p>' ;
    freeShippingSlider.html(string);
  }

  if (allVal === 2) {
    let string = '<div class="cart-step-progress"> <span class="step-box step-1 active"></span><span class="step-box step-2 active"></span><span class="step-box step-3"><span class="step-text">-15%</span></span><span class="step-box step-4"><span class="step-text">-18%</span></span><span class="step-box step-5"><span class="step-text">-20%</span></span></div>'
        + '<p class="productlisttitle text-center">' +	'<span id="top_wred">You are 1 product away from</span> <span id="top_red">15% off* + free shipping</span>'+'<span id="top_wred"> on your entire order!</span>' + '</p>' ;
    freeShippingSlider.html(string);
  }
  if (allVal == 3) {
    let string = '<div class="cart-step-progress"> <span class="step-box step-1 active"></span><span class="step-box step-2 active"></span><span class="step-box step-3 active"><span class="step-text">-15%</span></span><span class="step-box step-4"><span class="step-text">-18%</span></span><span class="step-box step-5"><span class="step-text">-20%</span></span></div>'
        +'<p class="productlisttitle text-center">' +	'<span id="top_wred">You are 1 product away from</span> <span id="top_red">18% off* + free shipping</span>'+'<span id="top_wred"> on your entire order!</span>' + '</p>';
    freeShippingSlider.html(string);
  }
    if (allVal == 4) {
    let string = '<div class="cart-step-progress"> <span class="step-box step-1 active"></span><span class="step-box step-2 active"></span><span class="step-box step-3 active"><span class="step-text">-15%</span></span><span class="step-box step-4 active"><span class="step-text">-18%</span></span><span class="step-box step-5"><span class="step-text">-20%</span></span></div>'
        +'<p class="productlisttitle text-center">' +	'<span id="top_wred">You are 1 product away from</span> <span id="top_red">20% off* + free shipping</span>'+'<span id="top_wred"> on your entire order!</span>' + '</p>';
    freeShippingSlider.html(string);
  }
    if (allVal == 5) {
    let string = '<div class="cart-step-progress"> <span class="step-box step-1 active"></span><span class="step-box step-2 active"></span><span class="step-box step-3 active"><span class="step-text">-15%</span></span><span class="step-box step-4 active"><span class="step-text">-18%</span></span><span class="step-box step-5 active"><span class="step-text">-20%</span></span></div>'
        + '<p class="productlisttitle text-center">' +	'<span id="top_wred">Congrats you get</span> <span id="top_red">20% off* + free shipping</span>'+'<span id="top_wred"> on your entire order!</span>' + '</p>';
    freeShippingSlider.html(string);
  }
  */




  /* temprary hide *****
    if (allVal === 1) {
    let string = '<p class="productlisttitle">' +	'2 products away from <strong>15% OFF + FREE SHIPPING!</strong>' + '</p><div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 20%" aria-valuenow="33.33" aria-valuemin="0" aria-valuemax="100"></div>' + '</div>' + '' ;
    freeShippingSlider.html(string);
  }
    if (allVal === 2) {
    let string = '<p class="productlisttitle">' +	'1 product away from <strong>15% OFF + FREE SHIPPING!</strong>' + '</p><div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 40%" aria-valuenow="33.33" aria-valuemin="0" aria-valuemax="100"></div>' + '</div>' + '' ;
    freeShippingSlider.html(string);
  }

    if (allVal === 3) {
    let string = '<p class="productlisttitle pink-txt free-shipping">' +	'You get <strong>15% OFF + FREE SHIPPING!</strong>' + '</p><div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 60%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>' + '</div>' + '<p class="productlisttitle" style="margin-top:5px; margin-bottom:0px;">' +	'Add 1 more product to get <strong>18% OFF!</strong>' + '</p>' ;
    freeShippingSlider.html(string);
  }
    if (allVal === 4) {
    let string = '<p class="productlisttitle pink-txt free-shipping">' +	'You get <strong>18% OFF + FREE SHIPPING!</strong>' + '</p><div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 80%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>' + '</div>' + '<p class="productlisttitle" style="margin-top:5px; margin-bottom:0px;">' +	'Add 1 more product to get <strong>20% OFF!</strong></strong>' + '</p>' ;
    freeShippingSlider.html(string);
  }
    if (allVal === 5) {
    let string = '<p class="productlisttitle pink-txt free-shipping">' +	'You get <strong>20% OFF + FREE SHIPPING!</strong>' + '</p><div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>' + '</div>' + '' ;
    freeShippingSlider.html(string);
  }
    */

  /****** Black Friday Offer *****/

  if (allVal === 1) {
    let string = '<p class="productlisttitle">' +	'2 products away <span>from <strong>20% OFF + FREE SHIPPING!</strong></span>' + '</p><div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 16.666%" aria-valuenow="33.33" aria-valuemin="0" aria-valuemax="100"></div>' + '</div><div class="blackfriday-offer"><strong>Black Friday Sale</strong></div>' + '' ;
    freeShippingSlider.html(string);
  }else if (allVal === 2) {
    let string = '<p class="productlisttitle">' +	'1 products away <span>from <strong>20% OFF + FREE SHIPPING!</strong></span>' + '</p><div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 33.12%" aria-valuenow="33.33" aria-valuemin="0" aria-valuemax="100"></div>' + '</div><div class="blackfriday-offer"><strong>Black Friday Sale</strong></div>' + '' ;
    freeShippingSlider.html(string);
  }else if (allVal === 3) {
    let string = '<p class="productlisttitle">' +	'<span>You get <strong>20% OFF + FREE SHIPPING!</strong></span>' + '</p><div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 50%" aria-valuenow="33.33" aria-valuemin="0" aria-valuemax="100"></div>' + '</div><div class="blackfriday-offer"><strong>Black Friday Sale: </strong> Add 1 more product to get  <strong>25% OFF!</strong></div>' + '' ;
    freeShippingSlider.html(string);
  }else if (allVal === 4) {
    let string = '<p class="productlisttitle">' +	'<span>You get <strong>25% OFF + FREE SHIPPING!</strong></span>' + '</p><div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 16.32%" aria-valuenow="33.33" aria-valuemin="0" aria-valuemax="100"></div>' + '</div><div class="blackfriday-offer"><strong>Black Friday Sale: </strong> Add 1 more product to get  <strong>35% OFF!</strong></div>' + '' ;
    freeShippingSlider.html(string);
  }else if (allVal === 5) {
    let string = '<p class="productlisttitle">' +	'<span>You get <strong>35% OFF + FREE SHIPPING!</strong></span>' + '</p><div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 84%" aria-valuenow="33.33" aria-valuemin="0" aria-valuemax="100"></div>' + '</div><div class="blackfriday-offer"><strong>Black Friday Sale: </strong> Add 1 more product to get  <strong>40% OFF!</strong></div>' + '' ;
    freeShippingSlider.html(string);
  }else if (allVal === 6) {
    let string = '<p class="productlisttitle">' +	'<span>You get <strong>40% OFF + FREE SHIPPING!</strong></span>' + '</p><div class="progress">' + '<div class="progress-bar" role="progressbar" style="width: 100%" aria-valuenow="33.33" aria-valuemin="0" aria-valuemax="100"></div>' + '</div><div class="blackfriday-offer"><strong>Black Friday Sale</strong></div>' + '' ;
    freeShippingSlider.html(string);
  }

}

function trySplitVariations() {
  $("#CartContainer .ajaxcart__product p.text-left span.ajaxcart__product-meta small").each(function (index) {
    let thisHtml = $(this).html();
    let strings = thisHtml.split('|');
    let output = '';
    for (i = 0; i < strings.length; i++) {
      output = output + '<span>' + strings[i] + '</span>';
    }
    $(this).html(output);
  });
}

function register_form(){
  jQuery('#register_form').toggle();
  jQuery('#CustomerLoginForm').toggle();
}


function custom_product_filter(filter_id){
  jQuery('.boost-pfs-filter-button').each(function(){
    if(jQuery(this).find('.boost-pfs-filter-option-value').text() == filter_id){
      jQuery(this).trigger('click');

      $('html, body').animate({
        scrollTop: $('.collection-title-section').offset().top - 120
      }, 'slow');
    }
  });
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function ge_bread_carm_prev_page(){
  const collectionName = $('.prev_visited_page > a').text().trim()

  if (collectionName === 'dossier originals' || collectionName === 'Unisex') {
    $('.prev_visited_page').hide();
    $('.prev_visited_page').next().hide();
  }
  var oldURL = document.referrer;
  if (oldURL === '') oldURL = 'https://dossier.co/';
  //console.log(document);

  var result = oldURL.replace(/(^\w+:|^)\/\//, '');

  var url_para = result.split('/');
  var old_title =  url_para[url_para.length - 1];
  old_title = old_title.replace('-',' ');

  var product_page = false;

  for(var i= 0; i <= url_para.length; i++){
    if(url_para[i] == 'products'){
      product_page = true;
    }
  }

  if(old_title == 'all'){
    $('.prev_visited_page').hide();
    $('.prev_visited_page').next().hide();
  }
  if(product_page == false){
    //console.log(old_title[0]);
    setCookie('bread_carm_title', old_title, 30);
    setCookie('bread_carm_url', oldURL, 30);
    $('.prev_visited_page a').attr('href', oldURL);
    $('.prev_visited_page a span').text(old_title);
  }else{
    if(getCookie('bread_carm_title') == '' || getCookie('bread_carm_title') == undefined || getCookie('bread_carm_title') == null ){
      $('.prev_visited_page').hide();
      $('.prev_visited_page').next().hide();
    }else{
      $('.prev_visited_page a span').text(getCookie('bread_carm_title'));
    }
    if(getCookie('bread_carm_url') == '' || getCookie('bread_carm_url') == undefined || getCookie('bread_carm_url') == null ){
      $('.prev_visited_page').hide();
      $('.prev_visited_page').next().hide();
    }else{
      $('.prev_visited_page a').attr('href',getCookie('bread_carm_url'));
    }
    if(getCookie('bread_carm_title') == 'all'){
      $('.prev_visited_page').hide();
      $('.prev_visited_page').next().hide();
    }
  }

  if(old_title == '' && getCookie('bread_carm_title') == ''){
    $('.prev_visited_page').hide();
    $('.prev_visited_page').next().hide();
  }

  if(getCookie('bread_carm_title').includes('=') == true || getCookie('bread_carm_title').includes('?') == true ){
    $('.prev_visited_page').hide();
    $('.prev_visited_page').next().hide();
  }

  if(old_title.includes('=') == true || old_title.includes('?') == true ){
    $('.prev_visited_page').hide();
    $('.prev_visited_page').next().hide();
  }

}
ge_bread_carm_prev_page();


$(document).ready(function () {
  $("#icons_button_ids").click(function(){
    $('#buymore').modal('show');
  });
// $('#item_1').removeClass('active');

  $('.product-grid').on('mouseenter', function(){
    var img_src = jQuery(this).find('.product-grid-image').find('img').attr('data-hover-src');
    jQuery(this).find('.product-grid-image').find('img').attr('src', img_src);
    jQuery(this).find('.product-grid-image').addClass('active-hover');
  });
  $('.product-grid').on('mouseleave', function(){
    var img_src = jQuery(this).find('.product-grid-image').find('img').attr('data-src');
    jQuery(this).find('.product-grid-image').find('img').attr('src', img_src);
    jQuery(this).find('.product-grid-image').removeClass('active-hover');
  });


  $(document).on('mouseenter','.boost-pfs-filter-product-item', function(){
    jQuery(this).find('.boost-pfs-filter-product-item-image').addClass('active-hover');
  });

  $(document).on('mouseleave','.boost-pfs-filter-product-item', function(){
    jQuery(this).find('.boost-pfs-filter-product-item-image').removeClass('active-hover');
  });



  jQuery('.tabbed-menu a').on('click', function(e){
    e.preventDefault();
    jQuery('.tabbed-menu li').removeClass('active');
    jQuery(this).parent('li').addClass('active');

    var section_id = jQuery(this).attr('href');
    jQuery('.tabbed-body .products-carousel').hide();
    jQuery(section_id).show();
    $('.owl-carousel-slider-hdd').slick('setPosition');
    return false;
  });

  jQuery('.dropdown-parent .dropdown-title a').on('click', function(){
    var link_id = jQuery(this).attr('href');
    if(link_id.includes('#') == true){

    }
  });

  jQuery(window).on('load', function(){
    jQuery('.page-loader-overlay').fadeOut();

  });



  jQuery('.collapsibles-wrapper .collapsible-trigger').on('click', function(){
    jQuery(this).addClass('current');

    jQuery('.collapsibles-wrapper .collapsible-trigger').each(function(){
      if(jQuery(this).hasClass('active') == true && jQuery(this).hasClass('current') == false ){
        jQuery(this).trigger('click');
      }
    });

    jQuery(this).toggleClass('active');
    var tab_id = "#"+jQuery(this).attr('aria-controls');
    jQuery(tab_id).slideToggle();
    jQuery(this).removeClass('current');
  });

  $('.boost-pfs-filter-refine-by-wrapper-h').bind('DOMSubtreeModified', function(){
    //console.log('changed');
  });

  $('.order-detail-view').on('click', function(e){
    e.preventDefault();
    var lightbox_id = $(this).attr('href');
    $('body').find(lightbox_id).fadeIn();
    $('.account-wrapper').css({'min-height': $('.order-details-container').height() + 100 + 'px'});
    $('html').addClass('drawer-open-order');
    return false;
  });

  $('.close-order-detail').on('click', function(e){
    e.preventDefault();
    var lightbox_id = $(this).attr('href');
    $(lightbox_id).fadeOut();
    $('.account-wrapper').css('min-height', 'auto');
    $('html').removeClass('drawer-open-order');
    return false;
  });

  $('.mobile-menu-parent-link').on('click', function(e){
    e.preventDefault();
    if($(this).hasClass('new_screen')){
      var dataId = '#' + $(this).attr("data-id");
      console.log(dataId, $(this));
      $('.nav-mobile-main-wrapper').toggle();
      $(dataId).toggle();
      $('.mobile-submenu-title-back').one('click', function(e){
        $('.nav-mobile-main-wrapper').toggle();
        $(dataId).toggle();
        console.log(dataId);
        $('.mobile-submenu-title-back').off('click');
      });
    }
    else{
      $(this).parents('li').find('.dropdown-mobile').slideToggle();
      $(this).parents('li').find('.mobile-submenu-open').toggle();
      $(this).parents('li').find('.mobile-submenu-close').toggle();
    }
    return false;
  });
  
  $('.mobile-nav-close a').on('click', function(e){
    e.preventDefault();
    $('.navbar-icon').trigger('click');
    $('.mobile-search-close').trigger('click');
    $('#mobile-nav-box > ul > li:nth-child(1) > ul').slideUp()
  });
  $('.js-open-hamburger-menu').on('click', function(){
    console.log('Open hamburger menu');
    $('#mobile-nav-box > ul > li:nth-child(1) > ul').slideDown()
    // Hide plus icon
    $('#mobile-nav-box > ul > li:nth-child(1) > div > span > span.menu-dropdown-icon.plus-icon').hide();
    // Show minus icon
    $('#mobile-nav-box > ul > li:nth-child(1) > div > span > span.menu-dropdown-icon.minus-icon').show()
  })

  const $mobileSearchList = $('.mobile-search-list');
  $('.mobile_search_field').on('focus', function(){
    $mobileSearchList.fadeIn();
  });

  $mobileSearchList.on('click', '.list-mostpopulare-li a', function(){
    var keyword = $(this).text();
    $('#searchmodel_btn').trigger('click');
  });

  $('.clear-filter').on('click', function(){
    $('#filter--lightbox-wrapper').find('.boost-pfs-filter-button.boost-pfs-filter-clear').trigger('click');
  });

  $('#CartDrawer').on('click', '.cart-itembox-item button', function(){
    $(this).parents('.cart-itembox-item').find('.mini-cart-loader').css({'display': 'flex'});
  });

  $('#CartDrawer').on('click', '.cart-sliderbox .cart_add', function(){
    $(this).parents('.cart-sliderbox').find('.mini-cart-loader').css({'display': 'flex'});
  });

  $(document).on('click','.sticky-checkout', function(){
    $('body').find('.main-cart-checkout').trigger('click');
    //$('#CartDrawer').find('form.cart.ajaxcart').submit();
  });

  $(document).on('click','#outer_div_ofs', function(){
    $('#BIS_frame').fadeIn();
  });


  $(document).on('click','.tab-menu-lsit a', function(e){
    e.preventDefault();
    $('.tab-menu-lsit li').removeClass('active');
    $(this).parents('li').addClass('active');
    $($(this).attr('href')).show().siblings().hide();
    return false;
  });




  $(window).on('load', function(){
    $('.boost-pfs-filter-product-item-regular-price').each(function(){
      var price = $(this).attr('data-proce');
      if(price !== null && price !== undefined && price !== ''){
        $(this).html(price);
      }
    });

    $('[data-bg-src]').each(function(){
      var bg_src = $(this).attr('data-bg-src');
      if(bg_src !== null && bg_src !== undefined && bg_src !== ''){
        $(this).css({'background-image': 'url(\''+bg_src+'\')'});
      }
    });


  });

  $(window).on('load scroll', function(){
    var scroltop = $(window).scrollTop();
    var top_dis = scroltop + 0;
    //console.log(top_dis);
    var window_w = $(window).width();
    var window_h = $(window).height() * 2;

    $('.resizeable-image').each(function(){

      var mobile_img = $(this).attr('data-mobile-src');
      var desktop_img = $(this).attr('data-desktop-src');
      if(window_w >= 768){
        //console.log('desktop');
        $(this).attr('src', desktop_img);
      }else{
        //console.log('mobile');
        $(this).attr('src', mobile_img);
      }
    });

    if(top_dis > 200){

      $('.product-image-lazyload').each(function(){
        var alt = $(this).attr('data-alt');
        var data_src = $(this).attr('data-src');
        var data_hover_src = $(this).attr('data-hover-src');
        var data_current_src = $(this).attr('src');

        if(data_current_src == null || data_current_src == undefined || data_current_src == ''){
          var img = '<img src="'+data_src+'" width="100" height="auto" data-src="'+data_src+'" data-hover-src="'+data_hover_src+'" class="lazyloaded" alt="'+alt+'" />';
          //console.log(img);
          $(this).replaceWith(img);
        }else{
          $(this).attr('src', data_src);
        }
      });

      $('[data-gallery-src]').each(function(){
        var desktop_img = $(this).attr('data-gallery-src');
        var alt = $(this).attr('data-alt');
        var img = '<img src="'+desktop_img+'" width="100" height="auto"  class="lazyloaded" alt="'+alt+'" />';
        $(this).replaceWith(img);
      });
    }

    var page_num = get_url_param('page');
    if(page_num == undefined || page_num == null || page_num == '' || page_num == '1'){
      $('.top-arrow-btn').hide();
    }else{
      if(scroltop < window_h){
        $('.top-arrow-btn').hide();
      }else{
        $('.top-arrow-btn').show();
      }
    }


  });


  $('.top-arrow-btn a').on('click', function(){
    if(window.location.href.indexOf("?") > -1) {
      var newUrl = refineUrl();
      window.history.pushState(document.title, document.title, ""+newUrl );
    }

    $('html, body').animate({
      scrollTop: $('.collection-title-section').offset().top - 120
    }, 'slow');
  });


  var page_num = get_url_param('page');
  if(page_num == undefined || page_num == null || page_num == ''){

  }else{
    if(window.location.href.indexOf("?") > -1) {
      var newUrl = refineUrl();
      window.location.href = newUrl;
      //window.history.pushState(document.title, document.title, ""+newUrl );
    }
  }

  $('.coming_soon_product').on('click', function(){
    const $productWrapper = $('.product-section-wrapper');
    if($productWrapper && $productWrapper.length > 0) {
      const title = $('.coming-soon-form-wrapper .product-name').text();
      $('.coming-soon-form-wrapper input[aria-label=Product]').focus();
      $('.coming-soon-form-wrapper input[aria-label=Product]').val(title);
      $('.coming-soon-form-wrapper').fadeIn();
      $('.coming-soon-form-wrapper input[placeholder=Product]').parents('div[data-testid=form-row]').hide();
    } else {
      const $productComingSoonForm = $(this).closest('.product-grid').find('.coming-soon-form-wrapper');
      const title = $productComingSoonForm.find('.product-name').text();
      $productComingSoonForm.find('input[aria-label=Product]').focus();
      $productComingSoonForm.find('input[aria-label=Product]').val(title);
      $productComingSoonForm.fadeIn();
    }
  });

  $(document).on('focus blur','.coming-soon-form-wrapper input[type=email]', function(){
    const $productWrapper = $('.product-section-wrapper');
    if($productWrapper && $productWrapper.length > 0) {
      var title = $('.coming-soon-form-wrapper .product-name').text();
      $('.coming-soon-form-wrapper input[aria-label=Product]').val(title);
    } else {
      const $productComingSoonForm = $(this).closest('.product-grid').find('.coming-soon-form-wrapper');
      const title = $productComingSoonForm.find('.product-name').text();
      $productComingSoonForm.find('input[aria-label=Product]').val(title);
    }
  });

  $('.coming-soon-form-wrapper .action-close').on('click', function(){
    $('.coming-soon-form-wrapper').fadeOut();
  });

  $(document).on('click','.cartfull', function(e){
    e.prevntDefault();
    return false;
  });



  $('#RecoverPassword').on('click', function(){
    var form_id = $(this).attr('href');
    $('#password-login-form').hide();
    $(form_id).show();
  });
  $('#HideRecoverPasswordLink').on('click', function(){
    var form_id = $(this).attr('href');
    $('#password-login-form').show();
    $('#password-reset-form').hide();
  });



  $('.marquee').marquee({
    duration: 21000,
    gap: 0,
    delayBeforeStart: 0,
    direction: 'left',
    duplicated: true
  });
  $('.marquee').removeClass('overflow-hidden');

  $('.close-lightbox').on('click', function(){
    $('.product-lightbox-wrappper').fadeOut();
  });
  $('.open-product-lightbox').on('click', function(){
    $('.product-lightbox-wrappper').fadeIn();
  });


  $('.holiday-collection-grid a').on('click', function(){
    $(this).find('.btn').toggleClass('btn-primary btn-outline-primary');
  });

  $(document).on('click','.fancybox-stage div', function(event){
    event.stopPropagation();
    if($(this).find('.fancybox-content').length > 0){$('body').find('.fancybox-button.fancybox-button--close').trigger('click');}else{

    }
  });

  $('#close-announcementbar-lightbox').on('click', function(){
    $('.announcementbar-lightbox').fadeOut();
  });
  $('.open-discount-lightbox').on('click', function(){
    $('.announcementbar-lightbox').fadeIn();
  });

  $('body').on('click', '.close-dossier-plus-lightbox', function(){
    $('.dossier-plus-lightbox').fadeOut();
  });
  $('body').on('click', '.open-dossier-plus-lightbox', function(){
    $('.dossier-plus-lightbox').fadeIn();
  })

  $('.faq-clicker').on('click',function() {
    var $this = $(this);
    $this.addClass('current');
    $('.faq-clicker.active').each(function(){
      if($(this).hasClass('current') == false){
        $(this).trigger('click');
      }
    });
    $this.toggleClass('active');
    $this.next('.faq-content').slideToggle();
    $this.removeClass('current');
  });
});

//-----------------------------------------New lazyload algoritm---------------------------------------------------------------------
// Needs class loadlazy and scr attr set into data-src or data-desktop-src & data-mobile-src, or data-desktop-image & data-mobil-image

document.addEventListener("DOMContentLoaded",setLazy);
function setLazy(){
  let options = {
    rootMargin: '0%',
    threshold: 0
  }
  let lazyObverser = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if(entry.isIntersecting){
        if(entry.target.dataset.src){
          entry.target.src = entry.target.dataset.src;
          entry.target.classList.remove('lazyload');
          entry.target.classList.add('lazyloaded');
        }
        else if(entry.target.dataset.desktopSrc && window.innerWidth > 767){
          if(entry.target.dataset.desktopWidth && entry.target.dataset.desktopHeight){
            entry.target.width = entry.target.dataset.desktopWidth;
            entry.target.height = entry.target.dataset.desktopHeight;
          }
          entry.target.src = entry.target.dataset.desktopSrc;
          entry.target.classList.remove('lazyload');
          entry.target.classList.add('lazyloaded');
        }
        else if(entry.target.dataset.mobileSrc && window.innerWidth <= 767){
          if(entry.target.dataset.mobileWidth && entry.target.dataset.mobileHeight){
            entry.target.width = entry.target.dataset.mobileWidth;
            entry.target.height = entry.target.dataset.mobileHeight;
          }
          entry.target.src = entry.target.dataset.mobileSrc;
          entry.target.classList.remove('lazyload');
          entry.target.classList.add('lazyloaded');
        }
        else if(entry.target.dataset.desktopImage && window.innerWidth > 767){
          entry.target.src = entry.target.dataset.desktopImage;
          entry.target.classList.remove('lazyload');
          entry.target.classList.add('lazyloaded');
        }
        else if(entry.target.dataset.mobilImage && window.innerWidth <= 767){
          entry.target.src = entry.target.dataset.mobilImage;
          entry.target.classList.remove('lazyload');
          entry.target.classList.add('lazyloaded');
        }
        if(entry.target.dataset.srcset && entry.target.dataset.sizes){
          entry.target.srcset = entry.target.dataset.mobilImage;
          entry.target.sizes = entry.target.dataset.mobilImage;
          if(entry.target.classList.contains('lazyload')){
            entry.target.classList.remove('lazyload');
            entry.target.classList.add('lazyloaded');
          } 
        }
      }
    });
  }, options);
  document.querySelectorAll('.lazyload').forEach((image) => {lazyObverser.observe(image)});

  // setting mutation observer for the elements that are added after DOMContentLoaded
  let optionsM = {
    attributes: true, 
    childList: true, 
    subtree: true
  }
  let mutObverser = new MutationObserver((mutationList) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        document.querySelectorAll('.lazyload').forEach((image) => {lazyObverser.observe(image)});
        //Hover pentru produsele din colectii dupa aplicare filtre
        $('.product-grid').on('mouseenter', function(){
          var img_src = jQuery(this).find('.product-grid-image').find('img').attr('data-hover-src');
          jQuery(this).find('.product-grid-image').find('img').attr('src', img_src);
          jQuery(this).find('.product-grid-image').addClass('active-hover');
        });
        $('.product-grid').on('mouseleave', function(){
          var img_src = jQuery(this).find('.product-grid-image').find('img').attr('data-src');
          jQuery(this).find('.product-grid-image').find('img').attr('src', img_src);
          jQuery(this).find('.product-grid-image').removeClass('active-hover');
        });
      }
    }
  });
  mutObverser.observe(document.body, optionsM);
}

// ---------------------------------------------------------------------------------------
// ----------- Quick Search Functionalities ----------------------------------------------
// ---------------------------------------------------------------------------------------
function update_search_popup($this) {
  var curr_sy = "$";
  var pr_name_ser = $this.closest('.advanced-search-box').find('.search_input_field').val();
  var prnameser = pr_name_ser.toLowerCase().toString();

  $this.closest('.advanced-search-box').find("#search_input_ch").val(pr_name_ser);

  if (pr_name_ser.length > 2) {
    $this.closest('.advanced-search-box').find(".d-none_res_resp").css("display", "block");
    $this.closest('.advanced-search-box').find("#default_search_div").css("display", "none");
    $this.closest('.advanced-search-box').find("#show_products_by_tags").css("display", "none");
    $this.closest('.advanced-search-box').find("#show_popular-products").css("display", "none");
    $this.closest('.advanced-search-box').find(".d-none_res_resp_tags").css("display", "none");
  } else {
    $this.closest('.advanced-search-box').find("#inspnsfn").css("display", "block");
    $this.closest('.advanced-search-box').find("#after_inspnsfn").css("display", "none");
    $this.closest('.advanced-search-box').find(".d-none_res_resp").css("display", "none");
    $this.closest('.advanced-search-box').find("#default_search_div").css("display", "none");
    $this.closest('.advanced-search-box').find("#show_products_by_tags").css("display", "block");
    $this.closest('.advanced-search-box').find("#show_popular-products").css("display", "block");
    $this.closest('.advanced-search-box').find(".d-none_res_resp_tags").css("display", "none");
  }

  $this.closest('.advanced-search-box').find("#search_word_type").text(pr_name_ser);
  $this.closest('.advanced-search-box').find("#search_word_type1").text(pr_name_ser);

  function titleCase(pr_name_ser1) {
    var splitStr = pr_name_ser1.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
  }

  var pr_name_ser_new_text = titleCase(pr_name_ser);
  const pr_name_ser_new = pr_name_ser.toLowerCase();
  jQuery.getJSON("/search/suggest.json", {
    "q": pr_name_ser_new.trim(),
    "resources": {
      "type": "product",
      "limit": 9080,
      "options": {
        "unavailable_products": "show",
        "fields": "title,product_type,variants.title,vendor,tag"
      }
    }
  }).done(function (response) {
    var productSuggestions = response.resources.results.products;

    if(productSuggestions.length == 0) {
      var topScents = [
        {'id': 270029258819, 'name': 'summer', 'title': 'Summer Scents', 'description': 'A page with out best summer perfumes, all in one place.', 'handle': 'summer-fragrances', 'url': '/collections/summer-fragrances'},
        {'id': 269773504579, 'name': 'fall', 'title': 'Fall Scents', 'description': 'A page with out best fall perfumes, all in one place.', 'handle': 'fall-perfumes', 'url': '/collections/fall-perfumes'},
        {'id': 270017298499, 'name': 'winter', 'title': 'Winter Scents', 'description': 'A page with out best winter perfumes, all in one place.', 'handle': 'winter-perfumes', 'url': '/collections/winter-perfumes'},
        {'id': 270015397955, 'name': 'spring', 'title': 'Spring Scents', 'description': 'A page with out best spring perfumes, all in one place.', 'handle': 'spring-fragrance', 'url': '/collections/spring-fragrance'}
      ];

      let currentValue = $this.val().toLowerCase();

      const scentIndex = topScents.findIndex(el => el.name.includes(currentValue));

      if(scentIndex >= 0) {
        $.ajax({
          url: `${topScents[scentIndex].url}/products.json`,
          async: false,
          dataType: 'json',
          success: function(data) {
            if (data.products.length > 0) {
              var topScentProducts = data.products.slice(0,4);

              for(let i=0; i < topScentProducts.length; i++) {
                topScentProducts[i].url = '/products/' + topScentProducts[i].handle;
                topScentProducts[i].image = topScentProducts[i].images[0].src;
                topScentProducts[i].price = topScentProducts[i].variants[0].price;
              }

              productSuggestions = [topScents[scentIndex], ...topScentProducts];
            }
          }
        });
      }

      var scentsSearch = 'seasons';
      if(scentsSearch.includes(currentValue)) {
        productSuggestions = [...topScents];
      }
    }

    var hidden_search_input = $("#search_input_ch").val().toLowerCase().toString();
    $this.closest('.advanced-search-box').find("#search_result_resp").empty();
    $this.closest('.advanced-search-box').find("#search_pro_nos").text(productSuggestions.length);

    if (productSuggestions.length > 0) {
      var counter = 0;
      for (var inc_re = 0; inc_re < productSuggestions.length; inc_re++) {
        var firstProductSuggestion = productSuggestions[inc_re];

        if (firstProductSuggestion.id != 4612106747971 && firstProductSuggestion.title.includes('Scents') == false) {
          var vendor_title_ = '';
          if(firstProductSuggestion.vendor) {
            vendor_title_ = firstProductSuggestion.vendor;
            if(firstProductSuggestion.vendor.includes('Inspired by')) {
              vendor_title_ = firstProductSuggestion.vendor.replace('Inspired by', '');
            }
          }
          var pppmm = (firstProductSuggestion.title).toLowerCase();

          if (pppmm.includes(prnameser) == false) {
            { continue; }
          }
          counter = counter + 1;

          var vvvmm = (vendor_title_.trim()).toLowerCase();
          var pppppp = pppmm.charAt(0);
          var hhhhhh = hidden_search_input.charAt(0);
          var vvvvvv = vvvmm.charAt(0);
          //new code for highligh words//
          var hhhhhhni = hidden_search_input;
          var hhhhhhnl = hidden_search_input.length;
          var ppppppns = pppmm;
          var product_title_after_slice_for_match = (ppppppns).slice(0, hhhhhhnl);
          var product_title_after_slice = firstProductSuggestion.title;
          var vvvvvvnns = vvvmm;
          var product_vendor_after_slice_for_match = (vvvvvvnns).slice(0, hhhhhhnl);
          var product_vendor_after_slice = (vvvvvvnns).slice(hhhhhhnl);
          //new code for highligh words//
          var p111 = product_title_after_slice_for_match.trim();
          var v111 = product_vendor_after_slice_for_match.trim();
          var h111 = hhhhhhni.trim();
          var h_hh = h111.toLowerCase();
          var pp_title = firstProductSuggestion.title;

          var product_html_title = firstProductSuggestion.title;

          if (vvvmm.includes(h111)) {
            var product_html_vendor_r = `${h111}`;
            h111 = h111.toLowerCase().replace(/\b[a-z]/g, function (letter) {
              return letter.toUpperCase();
            });
            var product_html_vendor = vendor_title_.replace(h111, product_html_vendor_r);
          } else {
            var product_html_vendor = vendor_title_.trim();
          }

          //search grid item//
          var serch_response = `
          <div class="product-grid">
            <a href="${firstProductSuggestion.url}" class="product-grid-innder w-100 font-primary font-weight-normal">
              <div class="product-grid-image">
                <img src="${firstProductSuggestion.image}" alt="product" class="w-100" />
              </div>
              <div class="product-meta">
                <div class="product-metadata">
                  <h5 class="product-item-title-h5"> ${product_html_title.replace(' ', '<br>')}</h5>
                  <div class="product-price">${curr_sy}${Math.floor(firstProductSuggestion.price)}</div>
                </div>
                <div class="product-grid-vendor">
                  <span class="inspired-span">  Inspired by  </span>
                  <span class="search-results-vendor">${product_html_vendor}</span>
                </div>
              </div>
            </a>
          </div>`;

          $this.closest('.advanced-search-box').find("#search_result_resp").append(serch_response);
          //search grid item//
        }
      }

      /*******************************************/
      if (counter == 0) {
        for (var inc_re = 0; inc_re < productSuggestions.length; inc_re++) {
          var firstProductSuggestion = productSuggestions[inc_re];

          if (firstProductSuggestion.id != 4612106747971 && firstProductSuggestion.title.includes('Scents') == false) {
            var vendor_title_ = '';
            if(firstProductSuggestion.vendor) {
              vendor_title_ = firstProductSuggestion.vendor;
              if(firstProductSuggestion.vendor.includes('Inspired by')) {
                vendor_title_ = firstProductSuggestion.vendor.replace('Inspired by', '');
              }
            }
            var pppmm = (firstProductSuggestion.title).toLowerCase();

            counter = counter + 1;
            var vvvmm = (vendor_title_.trim()).toLowerCase();
            var pppppp = pppmm.charAt(0);
            var hhhhhh = hidden_search_input.charAt(0);
            var vvvvvv = vvvmm.charAt(0);
            //new code for highligh words//
            var hhhhhhni = hidden_search_input;
            var hhhhhhnl = hidden_search_input.length;
            var ppppppns = pppmm;
            var product_title_after_slice_for_match = (ppppppns).slice(0, hhhhhhnl);
            var product_title_after_slice = firstProductSuggestion.title;
            var vvvvvvnns = vvvmm;
            var product_vendor_after_slice_for_match = (vvvvvvnns).slice(0, hhhhhhnl);
            var product_vendor_after_slice = (vvvvvvnns).slice(hhhhhhnl);
            //new code for highligh words//
            var p111 = product_title_after_slice_for_match.trim();
            var v111 = product_vendor_after_slice_for_match.trim();
            var h111 = hhhhhhni.trim();
            var h_hh = h111.toLowerCase();
            var pp_title = firstProductSuggestion.title;

            var product_html_title = firstProductSuggestion.title;

            if (vvvmm.includes(h111)) {
              var product_html_vendor_r = `${h111}`;
              h111 = h111.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                return letter.toUpperCase();
              });
              var product_html_vendor = vendor_title_.replace(h111, product_html_vendor_r);
            } else {
              var product_html_vendor = vendor_title_.trim();
            }

            //search grid item//
            var serch_response = `
            <div class="product-grid">
              <a href="${firstProductSuggestion.url}" class="product-grid-innder w-100 font-primary font-weight-normal">
                <div class="product-grid-image">
                  <img src="${firstProductSuggestion.image}" alt="product" class="w-100" />
                </div>
                <div class="product-meta">
                  <div class="product-metadata">
                    <h5 class="product-item-title-h5"> ${product_html_title.replace(' ', '<br>')}</h5>
                    <div class="product-price">${curr_sy}${Math.floor(firstProductSuggestion.price)}</div>
                  </div>
                  <div class="product-grid-vendor">
                    <span class="inspired-span">  Inspired by  </span>
                    <span class="search-results-vendor">${product_html_vendor}</span>
                  </div>
                </div>
              </a>
            </div>`;

            $this.closest('.advanced-search-box').find("#search_result_resp").append(serch_response);

          } else if (firstProductSuggestion.title.includes('Scents')) {
            counter = counter + 1;

            //search grid item//
            var serch_response = `
            <div class="product-grid product-grid-scent">
              <a href="${firstProductSuggestion.url}" class="product-grid-innder w-100 font-primary font-weight-normal">
                <div class="product-grid-content">
                  <div class="product-grid-heading">
                    <div class="product-grid-title"><strong>${firstProductSuggestion.title}</strong></div>
                    <div class="product-grid-description">${firstProductSuggestion.description}</div>
                  </div>
                  <div class="product-grid-action">Shop Now</div>
                </div>
              </a>
            </div>`;

            $this.closest('.advanced-search-box').find("#search_result_resp").append(serch_response);
          }
        }
      }


      $this.closest('.advanced-search-box').find("#search_pro_nos1").text(counter);

      /********************************************/

    } else {
      $this.closest('.advanced-search-box').find("#inspnsfn").css("display", "none");
      $this.closest('.advanced-search-box').find("#after_inspnsfn").css("display", "block");
      $this.closest('.advanced-search-box').find("#search_pro_nos1").text("0");
      $this.closest('.advanced-search-box').find(".d-none_res_resp").css("display", "none");
      $this.closest('.advanced-search-box').find("#default_search_div").css("display", "block");
    }
  });
};

$(document).ready(function () {
  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    $(".product-slider .slide-item a").attr("data-fancybox", "gallery");
  }else{
    if($(".product-slider").length > 0){
      $(".product-slider .slide-item img").imagezoomsl({
        zoomrange: [3, 3]
      });
    }
  }

  // Close fancybox on the product page, when tapping outside of the container
  $(document).on('touchstart', function(e){
    const target = e.target.className;
    console.log(target)
    if (
      target === 'fancybox-slide fancybox-slide--current fancybox-slide--image fancybox-slide--complete' ||
      target === 'fancybox-slide fancybox-slide--image fancybox-slide--current fancybox-slide--complete'
    ) $.fancybox.close();
  })

  $('.search_empty').on('click', function () {
    var $this = $(this);
    $this.closest('.advanced-search-box').find('.search_input_field').val('');
    $this.hide();

    $this.closest('.advanced-search-box').find('#show_products_by_tags').show();
    $this.closest('.advanced-search-box').find('.row.d-none_res_resp').hide();
    $this.closest('.advanced-search-box').find('#search_result_resp').html('');
    $this.closest('.advanced-search-box').find('#default_search_div').hide();
    $this.closest('.advanced-search-box').find('#show_popular-products').show();
    $this.closest('.advanced-search-box').find('.list-mostpopulare-link.active').removeClass('active');
  });

  $('.search_input_field').on('input', function(){
    var $this = $(this);
    var inputVal = $this.val();
    var clearBtn = $this.closest('.advanced-search-box').find('.search_empty');

    if ($this.val() == '' || $this.val() == undefined || $this.val() == null) {
      $this.closest('.advanced-search-box').find('.search_empty').hide();
    } else {
      if (inputVal.length > 2) {
        $this.closest('.advanced-search-box').find('.search_empty').show();
      } else {
        clearBtn.hide();
      }
    }

    update_search_popup($this);
  });

  $('.mobile-search-list').on('click', '.keyword-added a', function () {
    var $this = $(this);
    var keyword = $this.text();
    $this.closest('.advanced-search-box').find('#searchmodel_btn').trigger('click');
    $this.closest('.advanced-search-box').find('.search_input_field').val(keyword);
    update_search_popup();
  });

  //show products by tags
  $('#searchmodel .close').click(function () {
    var $this = $(this);
    setTimeout(function () {
      $this.closest('.advanced-search-box').find(".row.d-none_res_resp").css("display", "none");
      $this.closest('.advanced-search-box').find("#show_products_by_tags").css("display", "block");
      $this.closest('.advanced-search-box').find("#tags_name_ccc #tags_name_c").removeClass("active");
      $this.closest('.advanced-search-box').find(".row.d-none_res_resp_tags").css("display", "none");
      $this.closest('.advanced-search-box').find("#default_search_div").css("display", "none");
      $this.closest('.advanced-search-box').find('#show_popular-products').show();
      $this.closest('.advanced-search-box').find('.search_input_field').val('');
      $this.closest('.advanced-search-box').find('.search_empty').hide();
    }, 1000);
  });

  generateProductsOnClickTags = () => {
    $('#tags_name_ccc li').on('click', function () {
      var $this = $(this);
      var curr_sy = "$";
      var pr_name_serr = $this.find('a').text();

      var $searchInputWordType = $this.closest('.advanced-search-box').find("#search_word_type11");
      var $searchInputHeader = $this.closest('.advanced-search-box').find(".search_input_field");

      $searchInputHeader.val(pr_name_serr.trim());
      $searchInputWordType.text(pr_name_serr.trim());

      $this.closest('.advanced-search-box').find(".list-mostpopulare-link.active").removeClass("active");
      $this.find('a').addClass("active");

      // console.log('-------------------------------');
      // console.log(pr_name_serr.trim());
      // console.log('-------------------------------');

      jQuery.getJSON("/search/suggest.json", {
        "q": pr_name_serr.trim(),
        "resources": {
          "type": "product",
          "limit": 10080,
          "options": {
            "unavailable_products": "last",
            "fields": "vendor,tag"
          }
        }
      }).done(function (response) {
        $this.closest('.advanced-search-box').find('.search_empty').show();
        $this.closest('.advanced-search-box').find("#search_result_resp_tags_list").empty();
        $this.closest('.advanced-search-box').find(".d-none_res_resp_tags").show();
        $this.closest('.advanced-search-box').find("#show_popular-products").hide();
        $this.closest('#show_products_by_tags').hide();
        var productSuggestions = response.resources.results.products;
        $this.closest('.advanced-search-box').find("#search_pro_nos11").text(productSuggestions.length);
        if (productSuggestions.length > 0) {
          for (var inc_re = 0; inc_re < productSuggestions.length; inc_re++) {
            var firstProductSuggestion = productSuggestions[inc_re];
            var vendor_title_ = firstProductSuggestion.vendor.replace('Inspired by', '');
            //new code for highligh vendor text//
            var vendor_title_trim = vendor_title_.trim();
            var hidden_active_word = $this.closest('.advanced-search-box').find("#search_word_type11").text();
            var hidden_active_word_after_trim = hidden_active_word.trim();
            var hidden_active_word_after_trim_length = hidden_active_word_after_trim.length;
            var product_vendor_after_slice_for_match = (vendor_title_trim).slice(0, hidden_active_word_after_trim_length);
            var product_vendor_after_slice = (vendor_title_trim).slice(hidden_active_word_after_trim_length);
            var product_html_vendor = `${product_vendor_after_slice_for_match}<span>${product_vendor_after_slice}</span>`;

            //search grid item//
            var serch_response = `<div class="product-grid">
            <a href="${firstProductSuggestion.url}" class="product-grid-innder w-100 font-primary font-weight-normal">
        <div class="product-grid-image">
            <img src="${firstProductSuggestion.image}" alt="product" class="w-100" />
        </div>
        <div class="product-meta">
        <div class="product-metadata">
            <h5 class="product-item-title-h5"> ${firstProductSuggestion.title.replace(' ', '<br>')} </h5><div class="product-price"> ${curr_sy}${Math.floor(firstProductSuggestion.price)} </div>
           </div>
       <div class="product-grid-vendor">
                <span class="inspired-span">  Inspired by  </span>
                ${product_html_vendor}
            </div>
        </div>
    </a>
    </div>`;
            $this.closest('.advanced-search-box').find("#search_result_resp_tags_list").append(serch_response);
          }
        }
      });
    });
  }

  appendPopularTags = (searchBoxResults) => {
    const popularSearchesArray = ['Tom Ford', 'Baccarat Rouge', 'Jo Malone', 'Chanel', 'Vanilla'];

    const shopProductsbyTag = document.createElement('div');
    shopProductsbyTag.id = 'show_products_by_tags';
    const mostPopularSearchBox = document.createElement('div');
    mostPopularSearchBox.className = 'most-popular-searchbox';
    const popularSearchHeading = document.createElement('div');
    popularSearchHeading.className = 'search-heading';
    popularSearchHeading.textContent = 'Most popular searches';
    const mostPopularContent = document.createElement('div');
    mostPopularContent.className = 'content';
    const mostPopularList = document.createElement('ul');
    mostPopularList.id = 'tags_name_ccc';
    mostPopularList.className = 'list-mostpopuplare';

    for(var i = 0; i < popularSearchesArray.length; i += 1) {
      const mostPopularItem = document.createElement('li');
      mostPopularItem.className = 'list-mostpopulare-li';
      const mostPopularItemLink = document.createElement('a');
      mostPopularItemLink.href = 'javascript:void(0)';
      mostPopularItemLink.className = 'font-primary list-mostpopulare-link';
      mostPopularItemLink.id = 'tags_name_c';
      mostPopularItemLink.textContent = popularSearchesArray[i];

      mostPopularItem.append(mostPopularItemLink);
      mostPopularList.append(mostPopularItem);
    }

    mostPopularContent.append(mostPopularList);
    mostPopularSearchBox.append(popularSearchHeading);
    mostPopularSearchBox.append(mostPopularContent);
    shopProductsbyTag.append(mostPopularSearchBox);

    searchBoxResults.insertBefore(shopProductsbyTag, searchBoxResults.firstChild);

    generateProductsOnClickTags();
  }

  appendMostPopularProducts = (showPopularProducts, showBestSellerProducts) => {
    let col12 = document.createElement('div');
    col12.classList = 'col-12';

    let mostPopularProducts = document.createElement('div');
    mostPopularProducts.className = 'most-popular-products';
    col12.append(mostPopularProducts);

    let mostPopularProductsHeading = document.createElement('div');
    mostPopularProductsHeading.className = 'search-heading';
    mostPopularProductsHeading.textContent = 'Most popular products';
    mostPopularProducts.append(mostPopularProductsHeading);

    let mostPopularProductsList = document.createElement('div');
    mostPopularProductsList.className = 'row most-popular-products-list';
    for (let i = 0; i < searchPopularProducts.length; i++) {
      mostPopularProductsList.innerHTML += searchPopularProducts[i];
    }
    mostPopularProducts.append(mostPopularProductsList);

    let popularProductsNode = col12;
    showPopularProducts.appendChild(popularProductsNode);

    let bestSellersNode = col12.cloneNode(true);
    showBestSellerProducts.appendChild(bestSellersNode);

    const bestsellersHeading = document.querySelector('#show_bestseller-products .search-heading');
    bestsellersHeading.textContent = 'Checkout our bestsellers:';
  }

  $('#searchmodel_btn').click(function () {
    // Most Popular Searches
    const searchBoxResults = document.querySelector('#searchmodel .search-box-results .containwith-image');
    const productsbyTags = document.querySelector('#searchmodel #show_products_by_tags');
    if (!productsbyTags) {
      appendPopularTags(searchBoxResults);
    }

    // Most Popular Products
    const showPopularProducts = document.querySelector('#searchmodel #show_popular-products');
    const showBestSellerProducts = document.querySelector('#searchmodel #show_bestseller-products');
    const popularProductsList = document.querySelectorAll('#searchmodel #show_popular-products .product-grid');
    if (popularProductsList && popularProductsList.length == 0) {
      appendMostPopularProducts(showPopularProducts, showBestSellerProducts);
      yotpoWidgetsContainer.initWidgets();
    }

    $('#searchmodel').modal('show');
    setTimeout(function () {
      $(".search_input_field").focus();
    }, 1000);
  });

  if ($('.pare_WOMEN .megamenu-ul.bg-white .col-3').hasClass('active')) {
    $(".pare_WOMEN #left_WOMEN").addClass("active");
  }
  if ($('.pare_MEN .megamenu-ul.bg-white .col-3').hasClass('active')) {
    $(".pare_MEN #left_MEN").addClass("active");
  }
  if ($('.pare_UNISEX .megamenu-ul.bg-white .col-3').hasClass('active')) {
    $(".pare_UNISEX #left_UNISEX").addClass("active");
  }
});

$('.search-form').on('keyup keypress', function (e) {
  var keyCode = e.keyCode || e.which;
  if (keyCode === 13) {
    e.preventDefault();
    return false;
  }
});

// Toggle Menu - Mobile Search Box
var mobileSearchField = '.search_input_mobile';
var mobileSearchBox = '.mobile-search-box';
var mobileSearchClose = '.mobile-search-close';
var inlineSearchForm = '.inline-search-form';

$(mobileSearchField).on('click', function() {
  $(mobileSearchBox).show();
  $(mobileSearchClose).show();
  $(this).closest(inlineSearchForm).addClass('active');

  // Most Popular Searches
  const searchBoxResults = document.querySelector('.mobile-search-box .search-box-results .containwith-image');
  const productsbyTags = document.querySelector('.mobile-search-box #show_products_by_tags');
  if (!productsbyTags) {
    appendPopularTags(searchBoxResults);
  }

  // Most Popular Products
  const showPopularProducts = document.querySelector('.mobile-search-box #show_popular-products');
  const showBestSellerProducts = document.querySelector('.mobile-search-box #show_bestseller-products');
  const popularProductsList = document.querySelectorAll('.mobile-search-box #show_popular-products .product-grid');
  if (popularProductsList && popularProductsList.length == 0) {
    appendMostPopularProducts(showPopularProducts, showBestSellerProducts);
    yotpoWidgetsContainer.initWidgets();
  }
});

$(mobileSearchClose).on('click', function() {
  var $this = $(this);
  $this.hide();
  $this.closest('.advanced-search-box').find(".row.d-none_res_resp").css("display", "none");
  $this.closest('.advanced-search-box').find("#show_products_by_tags").css("display", "block");
  $this.closest('.advanced-search-box').find("#tags_name_ccc #tags_name_c").removeClass("active");
  $this.closest('.advanced-search-box').find(".row.d-none_res_resp_tags").css("display", "none");
  $this.closest('.advanced-search-box').find("#default_search_div").css("display", "none");
  $this.closest('.advanced-search-box').find('#show_popular-products').show();
  $(mobileSearchBox).hide();
  $(this).closest(inlineSearchForm).removeClass('active');
  $this.closest('.advanced-search-box').find('.search_input_field').val('');
  $this.closest('.advanced-search-box').find('.search_empty').hide();
});

// Collection - Search Box
var searchForm = '.search-page-form .inline-search-form';
var searchModelButton = '.search-item-nav #searchmodel_btn';
$(searchForm).on('click', function() {
  $(searchModelButton).click();
});